import * as React from 'react';
import { useSelector } from 'react-redux';
import { MortgageBanner } from '@cian/mobile-banner-component';
import { NotDesktop } from '../../../packages/Responsive';
import { dealTypeFromJsonQuery } from '../../../packages/Filters/shared/actions/suggestions/helpers';
import { EDealType } from '../../repositories/geo-suggest/v1/suggest';
import { trackGoToMortgagePageClick, trackDoNotShowClick } from './tracking';
import {
  getMortgageBannerHasBeenShownCookie,
  setMortgageBannerHasBeenShownCookie,
  getFullscreenBannerHasBeenShownSessionStorage,
} from '../../../browser/utils/mortgageBannerCookie';
import { useTrackIntoView } from './useTrackBannerView';
import { selectJsonQuery } from '../../selectors/results';
import { MORTGAGE_URL } from '../../constants/mortgage';

function MortgageBannerEnabledContainer() {
  const [showBanner, setShowBanner] = React.useState<boolean>(false);
  const trackIntoView = useTrackIntoView();

  React.useEffect(() => {
    const canShowBanner = !getMortgageBannerHasBeenShownCookie() && !getFullscreenBannerHasBeenShownSessionStorage();
    setShowBanner(canShowBanner);
  }, []);

  React.useEffect(() => {
    if (showBanner) {
      trackIntoView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBanner]);

  const closeBanner = () => {
    setShowBanner(false);
    setMortgageBannerHasBeenShownCookie();
  };

  const onAccept = React.useCallback(() => {
    closeBanner();
    trackGoToMortgagePageClick();
  }, []);

  const onDecline = React.useCallback(() => {
    closeBanner();
    trackDoNotShowClick();
  }, []);

  if (!showBanner) {
    return null;
  }

  return <MortgageBanner url={MORTGAGE_URL} handleAccept={onAccept} handleDecline={onDecline} />;
}

export function MortgageBannerContainer() {
  const jsonQuery = useSelector(selectJsonQuery);
  const isSale = dealTypeFromJsonQuery(jsonQuery) === EDealType.Sale;

  if (!isSale) {
    return null;
  }

  return (
    <NotDesktop>
      <MortgageBannerEnabledContainer />
    </NotDesktop>
  );
}
